<template>
  <tr
    :class="{
      'm-table-row': index >= 0,
      'm-table-row__summary': index === 0 && !isNested && withSummaryRow,
      'm-table-spacer-row': index === -1,
      'm-table-row__first': index === 0 && !isNested,
      'm-table-row_selected': Boolean(selected),
      'm-table-row_custom': color,
      'm-table-row_colored': !color,
      'm-table-row_disabled': disabled,
      'm-table-row_opened-dropdown': dropdownIsOpened,
      'm-table-row_nested-expanded': nestedRowExpanded
    }"
    :style="cssVars"
  >
    <slot />
  </tr>
</template>

<script>
  export default {
    name: 'MTableRow',
    props: {
      index: {
        type: Number,
        required: true
      },
      colorFunction: {
        type: Function,
        default: null
      },
      tableRow: {
        type: Object,
        default: Object
      },
      enabledKey: {
        type: String,
        default: null
      },
      uniqueKeyAttr: {
        type: String,
        default: 'id'
      },
      openedRowsKeys: {
        type: Array,
        default: Array
      },
      openedNestedRows: {
        type: Array,
        default: Array
      },
      selected: {
        type: Number,
        default: undefined
      },
      isNested: {
        type: Boolean,
        default: false
      },
      withSummaryRow: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      color () {
        if (this.colorFunction) {
          let colorInfo = this.colorFunction(this.tableRow, this.isNested);
          if (colorInfo && (colorInfo.color || colorInfo.background)) {
            return colorInfo;
          }
          return null;
        }
        return null;
      },
      disabled () {
        return this.enabledKey !== null && !this.tableRow[this.enabledKey];
      },
      dropdownIsOpened () {
        return this.openedRowsKeys.includes(this.tableRow[this.uniqueKeyAttr]);
      },
      nestedRowExpanded () {
        return this.openedNestedRows.includes(this.tableRow[this.uniqueKeyAttr]);
      },
      cssVars () {
        if (this.color) {
          return {
            '--custom-text-color': this.color.color || 'inherit',
            '--custom-row-color': this.color.background || 'inherit',
            '--custom-link-color': this.color.linkColor || 'inherit'
          };
        }
        return {};
      }
    }
  };
</script>

<style>
  .m-table-row {
    --row-color: var(--background-color);
    --row-hover-color: var(--action-background-color);
    --custom-text-color: #C3C3C3;
    --custom-row-color: #C4C4C4;
    --disabled-row-color: #F3F3F3;
    --custom-link-color: inherit;
    --row-cell-background: var(--row-color);
  }

  .m-table-row_custom {
    --row-cell-background: var(--custom-row-color);

    color: var(--custom-text-color);
    background-color: var(--custom-row-color);
  }

  .m-table-row_custom .m-table-cell {
    color: var(--custom-text-color);
  }

  .m-table-row_custom .m-table-cell a {
    color: var(--custom-link-color);
  }

  .m-table-row_colored {
    --row-cell-background: var(--row-color);

    background: var(--row-color);
  }

  .m-table-row_opened-dropdown {
    --row-cell-background: var(--row-hover-color);

    background: var(--row-hover-color);
  }

  .m-table-row_colored.m-table-row_disabled {
    --row-cell-background: var(--gray-table-color);

    background-color: var(--gray-table-color);
  }

  /* stylelint-disable no-descending-specificity */
  .m-table-row_selected,
  .m-table-row_colored:hover,
  .m-table-row_selected.m-table-row_disabled,
  .m-table-row_selected.m-table-row_colored.m-table-row_disabled:hover {
    --row-cell-background: var(--row-hover-color);

    background-color: var(--row-hover-color);
  }

  .m-table-row_colored.m-table-row_disabled:hover {
    --row-cell-background: var(--gray-color);

    background-color: var(--gray-color);
  }

  .m-table-row_nested-expanded {
    --row-cell-background: var(--action-background-color);

    background-color: var(--action-background-color);
  }

  .m-table-row__summary.m-table-row_custom,
  .m-table-row__summary.m-table-row_custom:hover {
    --row-cell-background: var(--custom-row-color, var(--background-color));

    background-color: var(--custom-row-color, var(--background-color));
  }

  .m-table-row__summary,
  .m-table-row__summary:hover {
    --row-cell-background: var(--background-color);

    background-color: var(--background-color);
  }
</style>
